import React, { useState, useRef, useEffect } from "react";
import "../App.css";
import ReactPlayer from "react-player";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import screenful from "screenfull";
import Controls from "../components/Controls";
import PropTypes from "prop-types";
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
    playerWrapper: {
        width: "100%",
        position: "relative",
        // "&:hover": {
        //   "& $controlsWrapper": {
        //     visibility: "visible",
        //   },
        // },
        [theme.breakpoints.up('md')]: {
            minHeight: '407px',
        },

    },

    controlsWrapper: {
        visibility: "hidden",
        position: "absolute",
        marginBottom: '5px',
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    topControls: {
        display: "flex",
        justifyContent: "flex-end",
        padding: theme.spacing(2),
    },
    middleControls: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    bottomWrapper: {
        display: "flex",
        flexDirection: "column",

        // background: "rgba(0,0,0,0.6)",
        // height: 60,
        padding: theme.spacing(2),
    },

    bottomControls: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        // height:40,
    },

    button: {
        margin: theme.spacing(1),
    },
    controlIcons: {
        color: "#777",

        fontSize: 50,
        transform: "scale(0.9)",
        "&:hover": {
            color: "#fff",
            transform: "scale(1)",
        },
    },

    bottomIcons: {
        color: "#999",
        "&:hover": {
            color: "#fff",
        },
    },

    volumeSlider: {
        width: 100,
    },
    root: {
        fontSize: '16px',
        color: '#fff',
        background: '#2a2a2a',
        width: '100%',
        position: 'relative',
        overflow: 'auto',
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,

    },
    videoImage: {
        paddingRight: '10px',
    },
    circularProgress: {
        color: '#bfbfbf',
        width: '4rem !important',
        height: '4rem !important',
        [theme.breakpoints.down('xs')]: {
            width: '2rem !important',
            height: '2rem !important',
        },

    }
}));




const format = (seconds) => {
    if (isNaN(seconds)) {
        return `00:00`;
    }
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours();
    const mm = date.getUTCMinutes();
    const ss = date.getUTCSeconds().toString().padStart(2, "0");
    if (hh) {
        return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
    }
    return `${mm}:${ss}`;
};

let count = 0;

const Video2 = ({ url, id }) => {

    const classes = useStyles();


    const [videoReady, setVideoReady] = useState(false);
    // const [count, setCount] = useState(0);
    const [timeDisplayFormat, setTimeDisplayFormat] = useState("normal");
    const [seekCheck, setSeek] = useState(false)

    const [state, setState] = useState({
        pip: false,
        playing: false,
        controls: false,
        light: false,
        muted: true,
        played: 0,
        duration: 0,
        playbackRate: 1.0,
        volume: 1,
        loop: false,
        seeking: false,
    });
    const playerRef = useRef(null);
    const playerContainerRef = useRef(null);
    const controlsRef = useRef(null);
    const {
        playing,
        light,
        muted,
        loop,
        playbackRate,
        pip,
        played,
        volume,
    } = state;


    const times_vid = JSON.parse(localStorage.getItem(`vid_${id}`));
    const reset_volume = JSON.parse(localStorage.getItem(`volume`));

    useEffect(() => {
        setLoading(true)
        setSeek(false)
        setVideoReady(true)
        return () => { setVideoReady(false) };
    }, [url])


    const handlePlayPause = () => {
        setState({ ...state, playing: !state.playing });


    };

    const handleRewind = () => {
        playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
    };

    const handleFastForward = () => {
        playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
    };

    const [loading, setLoading] = useState(true)
    const handleProgress = (changeState) => {
        if (changeState.playedSeconds < changeState.loadedSeconds)
            setLoading(false)
        else if (changeState.playedSeconds > changeState.loadedSeconds) setLoading(true)

        if (count > 3) {
            controlsRef.current.style.visibility = "hidden";
            count = 0;
        }
        if (controlsRef.current.style.visibility === "visible") {
            count += 1;
        }
        if (!state.seeking) {
            setState({ ...state, ...changeState });
        }

    };



    const handleSeekChange = (e, newValue) => {
        setState({ ...state, played: parseFloat(newValue / 100) });
    };

    const handleSeekMouseDown = (e) => {
        setState({ ...state, seeking: true });
    };

    const handleSeekMouseUp = (e, newValue) => {
        setState({ ...state, seeking: false });
        playerRef.current.seekTo(newValue / 100, "fraction");
    };

    const handleDuration = (duration) => {
        setState({ ...state, duration });
    };

    const handleVolumeSeekDown = (e, newValue) => {
        setState({ ...state, seeking: false, volume: parseFloat(newValue / 100) });

    };
    const handleVolumeChange = (e, newValue) => {
        setState({
            ...state,
            volume: parseFloat(newValue / 100),
            muted: newValue === 0 ? true : false,
        });
        localStorage.setItem(`volume`, JSON.stringify({ volume: parseFloat(newValue / 100) }))
    };

    const toggleFullScreen = () => {
        screenful.toggle(playerContainerRef.current);
    };

    const handleMouseMove = () => {
        if (seekCheck) {
            controlsRef.current.style.visibility = "visible";
            count = 0;
        }
    };

    const hanldeMouseLeave = () => {
        controlsRef.current.style.visibility = "hidden";
        count = 0;
    };

    const handleDisplayFormat = () => {
        setTimeDisplayFormat(
            timeDisplayFormat === "normal" ? "remaining" : "normal"
        );
    };


    const handlePlaybackRate = (rate) => {
        setState({ ...state, playbackRate: rate });
    };

    const hanldeMute = () => {
        setState({ ...state, muted: !state.muted });
    };

    const currentTime =
        playerRef && playerRef.current
            ? playerRef.current.getCurrentTime()
            : "00:00";

    useEffect(() => {
        if (seekCheck && playerRef && playerRef.current && currentTime)
            setTimeout(() =>
                localStorage.setItem(`vid_${id}`, JSON.stringify({ current_time: currentTime })), 5000);

    }, [currentTime])

    const duration =
        playerRef && playerRef.current ? playerRef.current.getDuration() : "00:00";
    const elapsedTime =
        timeDisplayFormat === "normal"
            ? format(currentTime)
            : `-${format(duration - currentTime)}`;

    const totalDuration = format(duration);

    function ready() {
        setLoading(false)
        if (reset_volume) {

            setState({
                ...state,
                volume: reset_volume.volume,
                muted: reset_volume.volume === 0 ? true : false,
            });
        }
        if (videoReady)
            setTimeout(() => setState({ ...state, playing: false }), 100);
        if (videoReady && times_vid) {
            setTimeout(() =>
                playerRef.current.seekTo(times_vid.current_time), setSeek(true),
                setVideoReady(false), 100);

        }

        else setSeek(true)

    }


    function onBufferEnd() {
        setLoading(true)

    }

    useEffect(() => {
        if (document.getElementById("iframe_id"))
            var js = document.getElementById("iframe_id")
    }, [])

    return (

        <Grid item xs={12} lg={12} style={{
            background: 'rgb(42, 42, 42)'
        }}>



            <iframe src="https://drive.google.com/file/d/1n0SjbUvUZ87HCWXG-cmZX10BusUXSXeW/preview" id="iframe_id" width="640" height="480" allow="autoplay"></iframe>
            <div
                onMouseMove={handleMouseMove}
                onMouseLeave={hanldeMouseLeave}
                ref={playerContainerRef}
                className={classes.playerWrapper}   >

                <ReactPlayer
                    // style={{ minHeight: '389px' }}
                    onReady={ready}
                    width="100%"
                    height="100%"
                    url="https://rr1---sn-4g5ednld.c.drive.google.com/videoplayback?expire=1649392615&ei=poNPYur-PNCTkASt5rn4CQ&ip=129.45.28.136&cp=QVRJQURfUVZPRlhPOm01Q000Q0JkYUNoa1RyYlBwT0Z1QnVTcmJmeXVlYVdpejRIRWVGRGVfNmg&id=ae0a1041a0216782&itag=22&source=webdrive&requiressl=yes&ttl=transient&susc=dr&driveid=1yW6_z3nPFgQEZlkwnJ6L16ZZhF4WYjIv&app=explorer&mime=video/mp4&vprv=1&prv=1&dur=837.195&lmt=1628162474041972&subapp=DRIVE_WEB_FILE_VIEWER&sparams=expire,ei,ip,cp,id,itag,source,requiressl,ttl,susc,driveid,app,mime,vprv,prv,dur,lmt&sig=AOq0QJ8wRgIhAIQzAQsO08FCvmAApag-B_adcbE6ub6Ea4VhY1VEXBRNAiEA4lkGwxSu-4qqDB_UBluX-84jsj2mTfQ_x9oCDADYzTs=&cpn=HFk_CpuH8Ws87Sy3&c=WEB_EMBEDDED_PLAYER&cver=1.20220406.01.00&redirect_counter=1&cm2rm=sn-hgnld76&req_id=9c11d5eefdaca3ee&cms_redirect=yes&cmsv=e&mh=ZH&mm=34&mn=sn-4g5ednld&ms=ltu&mt=1649378200&mv=m&mvi=1&pl=24&lsparams=mh,mm,mn,ms,mv,mvi,pl&lsig=AG3C_xAwRQIhAILHCOFdbQ6X-3c4Yg8Q2jDK8bGcODu1PjgwTEHAwOyDAiBlzQBZ6yTUY1AOV8UqipeZU4TOUWnDQwz4usNAT2_uqw%3D%3D"
                    config={{ file: { attributes: { controlsList: 'nodownload' } }, style: { display: 'block' } }}
                    onContextMenu={e => e.preventDefault()}
                    ref={playerRef}
                    pip={pip}
                    playing={playing}
                    controls={false}
                    light={light}
                    loop={loop}
                    playbackRate={playbackRate}
                    volume={volume}
                    muted={muted}
                    onProgress={handleProgress}
                    onBuffer={onBufferEnd}
                />

                {loading ? <div style={{
                    position: "absolute",
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: '100%'
                }}>
                    <Grid item xs={12} style={{
                        display: 'block',
                        left: 'calc(50%)',
                        marginLeft: '-17.5px',
                        marginTop: '-30px',
                        position: 'absolute',
                        top: 'calc(50%)',
                    }}>
                        <CircularProgress className={classes.circularProgress} />
                    </Grid>
                </div> : null}
                <Controls
                    ref={controlsRef}
                    onSeek={handleSeekChange}
                    onSeekMouseDown={handleSeekMouseDown}
                    onSeekMouseUp={handleSeekMouseUp}
                    onDuration={handleDuration}
                    onRewind={handleRewind}
                    onPlayPause={handlePlayPause}
                    onFastForward={handleFastForward}
                    playing={playing}
                    played={played}
                    elapsedTime={elapsedTime}
                    totalDuration={totalDuration}
                    onMute={hanldeMute}
                    muted={muted}
                    onVolumeChange={handleVolumeChange}
                    onVolumeSeekDown={handleVolumeSeekDown}
                    onChangeDispayFormat={handleDisplayFormat}
                    playbackRate={playbackRate}
                    onPlaybackRateChange={handlePlaybackRate}
                    onToggleFullScreen={toggleFullScreen}
                    volume={volume}
                />
            </div>

        </Grid>

    );
}
Video2.propTypes = {
    url: PropTypes.string.isRequired
};

export default Video2;